import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Paper,
  Typography,
  Box, Grid, Select
} from "@mui/material";
import Cookies from "js-cookie";
import api from "../../../../../services/api";
import dayjs from "dayjs";
import CadastrarProcedimentoTratamentoEmCampoAvulso from "./cadastrarProcedimentoTratamentoEmCampoAvulso.js";
import { Tooltip, Divider } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import { Delete, Brightness4, Brightness7 } from '@material-ui/icons';

export default function Cronograma({ ordemServicoRecebida, handleClickOpenExcluirProcedimento, listarInformacoes }) {


  const [agora, setAgora] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setAgora(dayjs());
    }, 60000); // atualiza a cada minuto

    return () => clearInterval(timer);
  }, []);

  const [pixelsPorHora, setPixelsPorHora] = useState(50);
  const [agruparPorExecutor, setAgruparPorExecutor] = useState(false);

  // Read dark mode from global cookie (set by NavBarGestao)
  const [darkMode, setDarkMode] = useState(() => {
    const saved = Cookies.get('darkMode');
    return saved === 'true';
  });

  // Poll cookie for changes (enables sync across components/tabs)
  useEffect(() => {
    const interval = setInterval(() => {
      const saved = Cookies.get('darkMode');
      const cookieValue = saved === 'true';
      if (cookieValue !== darkMode) {
        setDarkMode(cookieValue);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [darkMode]);


  const [ordemServico, setOrdemServico] = useState(null);

  useEffect(() => {
    setOrdemServico(ordemServicoRecebida);
  }, [ordemServicoRecebida]);



  // ---- DEBUG FLAG: altere para false para desligar logs ----
  const DEBUG = false;

  const [procedimentos, setProcedimentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]);

  const [procedimentoSelecionado, setProcedimentoSelecionado] = useState(null);
  const [dataInicial, setDataInicial] = useState(dayjs().format("YYYY-MM-DD"));
  const [horaInicial, setHoraInicial] = useState("08:00");
  const [horaFinal, setHoraFinal] = useState("09:30");



  function salvarTarefa() {
    // implementação futura — mantido vazio conforme seu arquivo original
  }

  // ============================
  // parseDataHora robusto
  // ============================
  function parseDataHora(valor) {
    if (!valor) return null;

    if (Array.isArray(valor)) {
      const [ano, mes, dia, hora = 0, minuto = 0, segundo = 0] = valor;
      const dt = dayjs(new Date(ano, mes - 1, dia, hora, minuto, segundo));
      if (DEBUG) console.log("parseDataHora ARRAY ->", valor, "=>", dt.format ? dt.format() : dt);
      return dt.isValid() ? dt : null;
    }

    if (typeof valor === "string") {
      const d = dayjs(valor);
      if (DEBUG) console.log("parseDataHora STRING ->", valor, "=>", d.format ? d.format() : d);
      return d.isValid() ? d : null;
    }

    if (typeof valor === "object") {
      const { year, month, day, hour = 0, minute = 0, second = 0 } = valor;
      if (year && month && day) {
        const dt = dayjs(new Date(year, month - 1, day, hour, minute, second));
        if (DEBUG) console.log("parseDataHora OBJ ->", valor, "=>", dt.format ? dt.format() : dt);
        return dt.isValid() ? dt : null;
      }
    }

    const fallback = dayjs(valor);
    if (DEBUG) console.log("parseDataHora FALLBACK ->", valor, "=>", fallback.format ? fallback.format() : fallback);
    return fallback.isValid() ? fallback : null;
  }






  // ============================
  //  INDICADORES GERAIS
  // ============================
  const indicadores = React.useMemo(() => {
    if (!tasks || tasks.length === 0) {
      return {
        totalPeso: 0,
        pesoConcluido: 0,
        pesoRestante: 0,
        percConcluido: 0,
        percRestante: 0,
        dataInicioPrevista: null,
        dataFimPrevista: null
      };
    }

    let totalPeso = 0;
    let pesoConcluido = 0;

    let menorDataInicio = null;
    let maiorDataFim = null;

    console.log("======= DEBUG INDICADORES =======");

    tasks.forEach((t) => {
      console.log("Tarefa ID:", t.id);

      console.log(" RAW inicio_previsto:", t.data_hora_inicio_prevista,
        " TYPE:", typeof t.data_hora_inicio_prevista);

      console.log(" RAW fim_previsto:", t.data_hora_fim_prevista,
        " TYPE:", typeof t.data_hora_fim_prevista);

      const peso = t.procedimento?.peso ?? 0;
      totalPeso += peso;

      if (t.status === 1) {
        pesoConcluido += peso;
      }

      // datas — parse retorna STRING → converter aqui!
      const iniStr = parseDataHora(t.data_hora_inicio_prevista);
      const fimStr = parseDataHora(t.data_hora_fim_prevista);

      const ini = iniStr ? dayjs(iniStr, "DD/MM/YYYY HH:mm:ss") : null;
      const fim = fimStr ? dayjs(fimStr, "DD/MM/YYYY HH:mm:ss") : null;

      console.log(" parse ini:", ini ? ini.format("DD/MM/YYYY HH:mm:ss") : "NULL");
      console.log(" parse fim:", fim ? fim.format("DD/MM/YYYY HH:mm:ss") : "NULL");
      console.log("---------------------------------");

      if (ini && (!menorDataInicio || ini.isBefore(menorDataInicio))) {
        menorDataInicio = ini;
      }
      if (fim && (!maiorDataFim || fim.isAfter(maiorDataFim))) {
        maiorDataFim = fim;
      }
    });

    console.log(">>> MENOR INICIO:", menorDataInicio ? menorDataInicio.format("DD/MM/YYYY HH:mm:ss") : "NULL");
    console.log(">>> MAIOR FIM:", maiorDataFim ? maiorDataFim.format("DD/MM/YYYY HH:mm:ss") : "NULL");
    console.log("=================================\n\n");

    const percConcluido = totalPeso > 0 ? ((pesoConcluido / totalPeso) * 100).toFixed(1) : 0;
    const percRestante = (100 - percConcluido).toFixed(1);

    return {
      totalPeso,
      pesoConcluido,
      pesoRestante: totalPeso - pesoConcluido,
      percConcluido,
      percRestante,
      dataInicioPrevista: menorDataInicio,
      dataFimPrevista: maiorDataFim
    };
  }, [tasks]);

  // ============================
  // converte ordemServico -> tasks (inclui inicioDt/fimDt)
  // ============================
  useEffect(() => {
    if (!ordemServico?.procedimentos_tratamento_em_campo) return;

    const convertidas = ordemServico.procedimentos_tratamento_em_campo.map((t) => {
      if (DEBUG) {
        console.log("RAW INICIO:", t.data_hora_inicio_prevista);
        console.log("RAW FIM:", t.data_hora_fim_prevista);
      }

      const inicioDt = parseDataHora(t.data_hora_inicio_prevista);
      let fimDt = parseDataHora(t.data_hora_fim_prevista);
      if (fimDt && fimDt.isValid()) {
        fimDt = fimDt.add(15, "minute");
      }


      if (DEBUG) {
        console.log("INICIO PARSED:", inicioDt ? inicioDt.format("YYYY-MM-DD HH:mm:ss") : inicioDt);
        console.log("FIM PARSED:", fimDt ? fimDt.format("YYYY-MM-DD HH:mm:ss") : fimDt);
        console.log("INICIO FORMAT:", inicioDt ? inicioDt.format("HH:mm") : null);
        console.log("FIM FORMAT:", fimDt ? fimDt.format("HH:mm") : null);
      }

      return {
        id: t.id_procedimento_execucao,
        id_procedimento_execucao: t.id_procedimento_execucao,
        procedimento: t.procedimento,
        data: inicioDt ? inicioDt.format("YYYY-MM-DD") : "",
        inicio: inicioDt ? inicioDt.format("HH:mm") : "",
        fim: fimDt ? fimDt.format("HH:mm") : "",
        data_hora_inicio_prevista: t.data_hora_inicio_prevista,
        data_hora_fim_prevista: t.data_hora_fim_prevista,
        inicioDt,
        fimDt,
        usuario_criador: t.usuario_criador,
        usuario_executor: t.usuario_executor,
        status: t.status,
        data_hora_inicio_execucao: t.data_hora_inicio_execucao,
        data_hora_fim_execucao: t.data_hora_fim_execucao,
        resultado: t.resultado,
        mensagem_criador: t.mensagem_criador,
        data_hora_cancelamento: t.data_hora_cancelamento,
        mensagem_cancelamento: t.mensagem_cancelamento,
        observacoes: t.observacoes,
        data_hora_pausa1: t.data_hora_pausa1,
        motivo_pausa1: t.motivo_pausa1,
        data_hora_pausa2: t.data_hora_pausa2,
        motivo_pausa2: t.motivo_pausa2,
        data_hora_pausa3: t.data_hora_pausa3,
        motivo_pausa3: t.motivo_pausa3,
      };
    });

    if (DEBUG) console.log("TASKS CONVERTIDAS:", convertidas);
    setTasks(convertidas);
  }, [ordemServico]);

  // ============================
  // agrupa por data ou executor
  // ============================
  const tarefasAgrupadas = React.useMemo(() => {
    if (agruparPorExecutor) {
      return tasks.reduce((acc, task) => {
        const key = task.usuario_executor?.nome_amigavel || "Não Designado";
        if (!acc[key]) acc[key] = [];
        acc[key].push(task);
        return acc;
      }, {});
    } else {
      return tasks.reduce((acc, task) => {
        if (!acc[task.data]) acc[task.data] = [];
        acc[task.data].push(task);
        return acc;
      }, {});
    }
  }, [tasks, agruparPorExecutor]);

  const chavesOrdenadas = React.useMemo(() => Object.keys(tarefasAgrupadas).sort(), [tarefasAgrupadas]);

  const detectOverlap = (task, allTasksInGroup) => {
    if (!task.inicioDt || !task.fimDt) return false;
    return allTasksInGroup.some(other => {
      if (other.id === task.id || !other.inicioDt || !other.fimDt) return false;
      // Overlap real: mesmo tempo físico
      return task.inicioDt.isBefore(other.fimDt) && task.fimDt.isAfter(other.inicioDt);
    });
  };

  const gerarHorariosDoDia = (tarefas) => {
    if (!tarefas || tarefas.length === 0) return [];

    let menor = null;
    let maior = null;

    tarefas.forEach((t) => {
      if (!t.inicioDt || !t.fimDt) return;
      if (!menor || t.inicioDt.isBefore(menor)) menor = t.inicioDt;
      if (!maior || t.fimDt.isAfter(maior)) maior = t.fimDt;
    });

    if (!menor || !maior) return [];

    // Ajusta para o início da hora/meia hora
    let cursor = menor.startOf("hour");
    if (menor.minute() >= 30) cursor = cursor.add(30, "minute");

    const limite = maior.add(30, "minute");
    const lista = [];

    while (cursor.isBefore(limite)) {
      lista.push(cursor); // Agora guardamos o objeto dayjs completo
      cursor = cursor.add(30, "minute");
    }

    return lista;
  };


  const calcularEstiloGantt = (task, horarios) => {
    if (!task.inicioDt || !task.fimDt || !horarios?.length) {
      return { left: "0px", width: "0px" };
    }

    const baseDt = horarios[0];
    const leftMinutes = task.inicioDt.diff(baseDt, "minute");
    const durationMinutes = task.fimDt.diff(task.inicioDt, "minute");

    const pxPorMinuto = pixelsPorHora / 30;

    return {
      left: `${leftMinutes * pxPorMinuto}px`,
      width: `${durationMinutes * pxPorMinuto}px`,
    };
  };

  const calcularEstiloExecucaoReal = (task, horarios) => {
    if (!task.data_hora_inicio_execucao || !horarios?.length) return null;

    const startActual = parseDataHora(task.data_hora_inicio_execucao);
    const endActual = (task.data_hora_fim_execucao || task.data_hora_execucao)
      ? parseDataHora(task.data_hora_fim_execucao || task.data_hora_execucao)
      : agora;

    if (!startActual || !startActual.isValid()) return null;

    const baseDt = horarios[0];
    const leftMinutes = startActual.diff(baseDt, "minute");
    let durationMinutes = endActual.diff(startActual, "minute");

    if (durationMinutes < 5) durationMinutes = 5;

    const pxPorMinuto = pixelsPorHora / 30;
    return {
      left: `${leftMinutes * pxPorMinuto}px`,
      width: `${durationMinutes * pxPorMinuto}px`,
      height: 10,
      bottom: 4,
      position: 'absolute',
      backgroundColor: '#2e7d32',
      borderRadius: 4,
      opacity: 0.9,
      zIndex: 2,
      border: '1px solid rgba(255,255,255,0.3)'
    };
  };



  const calcularLinhas = (tarefas) => {
    const linhas = [];

    tarefas.forEach((t) => {
      const ini = t.inicioDt;
      const fim = t.fimDt;

      let linha = 0;

      while (true) {
        const conflito = linhas[linha]?.some((tt) => {
          const ini2 = tt.inicioDt;
          const fim2 = tt.fimDt;

          return ini.isBefore(fim2) && fim.isAfter(ini2);
        });

        if (!conflito) break;
        linha++;
      }

      if (!linhas[linha]) linhas[linha] = [];
      linhas[linha].push(t);

      t.linha = linha;
    });

    return tarefas;
  };


  const [openCadastrarProcedimento, setOpenCadastrarProcedimento] = useState(false);


  function handleCloseCadastrarProcedimento(ordem) {
    setOpenCadastrarProcedimento(false);
    setOrdemServico(ordem)
    listarInformacoes();
  }


  const handleClickVizualizarProcedimento = (id) => {
    window.open(`/gestao/administracao/ordensdeservicos/vizualizarprocedimentoexecucao/${id}/ordemservico/${ordemServico.id_ordem_servico}`, '_blank');
  };



  function getTaskColors(task) {

    // ==========================
    // EM EXECUÇÃO (início != null e fim == null)
    // ==========================
    if (task.data_hora_inicio_execucao && !task.data_hora_fim_execucao) {
      return {
        bg: darkMode ? "#1b5e20" : "#C8F7C5",   // verde mais profundo no dark mode
        color: darkMode ? "#FFFFFF" : "#004d00", // Verde escuro no modo claro para contraste
        animating: true // habilita animação
      };
    }

    // STATUS 0 = Não Executado (Laranja)
    if (task.status === 0) {
      return {
        bg: darkMode ? "#b87000" : "#FFA726", // laranja mais escuro no dark mode
        color: darkMode ? "#FFFFFF" : "#4e342e", // Marrom escuro no modo claro para contraste
        animating: false
      };
    }

    // STATUS 9 = Cancelado
    if (task.status === 9) {
      return {
        bg: "#FFCDD2",
        color: "#8B0000",
        animating: false
      };
    }

    // STATUS 1 = Executado (verifica resultado)
    if (task.status === 1) {
      if (task.resultado === 1) {
        return {
          bg: "#66BB6A",
          color: "#FFFFFF",
          animating: false
        };
      }
      if (task.resultado === 0) {
        return {
          bg: "#E53935",
          color: "#FFFFFF",
          animating: false
        };
      }
    }

    // fallback
    return {
      bg: "#1976D2",
      color: "#FFFFFF", // Azul continua com branco por ser escuro
      animating: false
    };
  }
  function formatarDataHora(valor) {
    if (!valor) return "—";

    // Se vier array: [ano, mes, dia, hora, minuto, segundo]
    if (Array.isArray(valor)) {
      const [ano, mes, dia, hora, minuto, segundo] = valor;
      return `${dia.toString().padStart(2, "0")}/${mes.toString().padStart(2, "0")
        }/${ano} ${hora.toString().padStart(2, "0")}:${minuto.toString().padStart(2, "0")
        }:${segundo.toString().padStart(2, "0")}`;
    }

    // Se vier Date
    if (valor instanceof Date) {
      return valor.toLocaleString("pt-BR");
    }

    // Se vier string "2025-12-04 08:08:19"
    if (typeof valor === "string") {
      if (valor.includes("T")) {
        const d = new Date(valor);
        return d.toLocaleString("pt-BR");
      }
      // Formato SQL
      const partes = valor.split(/[- :]/);
      if (partes.length >= 6) {
        const [ano, mes, dia, hora, minuto, segundo] = partes;
        return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
      }
    }

    return "—";
  }


  // ============================
  // THEME COLORS
  // ============================
  const theme = {
    bg: darkMode ? "#121212" : "#e9eff3",      // Cinza suave para fundo
    paper: darkMode ? "#1e1e1e" : "#f5f8fa",   // Cinza muito claro para cartões
    text: darkMode ? "#ffffff" : "#1a1a1a",
    textSecondary: darkMode ? "#aaaaaa" : "#5a6a7a",
    border: darkMode ? "#333333" : "#d1d9e0",
    timelineSlot: darkMode ? "#2c2c2c" : "#f1f4f6",
    timelineActive: darkMode ? "#1a237e" : "#e2e8ed",
    timelineBorder: darkMode ? "#444" : "#ccd5de",
    headerBg: darkMode ? "#252525" : "#dde5ed",
    sidebarItem: darkMode ? "#2a2a2a" : "#edf1f4",
  };

  // ============================
  // RENDER
  // ============================
  return (
    <Box p={2} sx={{
      bgcolor: theme.bg,
      color: theme.text,
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      transition: "background-color 0.3s",
      overflow: "hidden" // evita scroll no body
    }}>
      <Paper elevation={3} sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        mb: 2,
        p: 1.5,
        alignItems: 'center',
        bgcolor: theme.paper,
        border: `1px solid ${theme.border}`,
        borderRadius: 2
      }}>
        <Button variant="contained" size="small" onClick={() => setOpenCadastrarProcedimento(true)} disabled={loading} sx={{ fontWeight: 'bold', height: 40 }}>
          + Tarefa
        </Button>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: '4px 8px', border: `1px solid ${darkMode ? '#555' : '#ccc'}`, borderRadius: 1.5 }}>
          <Typography variant="caption" sx={{ color: theme.textSecondary, fontWeight: 800 }}>VISTA:</Typography>
          <Button size="small" variant={agruparPorExecutor ? "text" : "contained"} onClick={() => setAgruparPorExecutor(false)} sx={{ minWidth: 70, height: 28, fontSize: '11px', color: !agruparPorExecutor ? '#ffffff' : theme.text }}>Data</Button>
          <Button size="small" variant={agruparPorExecutor ? "contained" : "text"} onClick={() => setAgruparPorExecutor(true)} sx={{ minWidth: 70, height: 28, fontSize: '11px', color: agruparPorExecutor ? '#ffffff' : theme.text }}>Executor</Button>

          <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

          <Typography variant="caption" sx={{ color: theme.textSecondary, fontWeight: 800 }}>ZOOM:</Typography>
          <Select
            size="small"
            value={pixelsPorHora}
            onChange={(e) => setPixelsPorHora(e.target.value)}
            sx={{
              minWidth: 100,
              height: 28,
              borderRadius: 1,
              fontSize: '11px',
              color: theme.text,
              '.MuiOutlinedInput-notchedOutline': { borderColor: theme.border },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: darkMode ? '#90caf9' : '#1976d2' },
              '.MuiSvgIcon-root': { color: theme.textSecondary }
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: theme.paper,
                  color: theme.text,
                  border: `1px solid ${theme.border}`,
                  '& .MuiMenuItem-root:hover': {
                    bgcolor: darkMode ? 'rgba(255, 255, 255, 0.08)' : '#e2e8ed'
                  }
                }
              }
            }}
          >
            <MenuItem value={30} sx={{ fontSize: '12px', color: theme.text, bgcolor: theme.paper }}>50%</MenuItem>
            <MenuItem value={50} sx={{ fontSize: '12px', color: theme.text, bgcolor: theme.paper }}>100%</MenuItem>
            <MenuItem value={80} sx={{ fontSize: '12px', color: theme.text, bgcolor: theme.paper }}>150%</MenuItem>
            <MenuItem value={120} sx={{ fontSize: '12px', color: theme.text, bgcolor: theme.paper }}>250%</MenuItem>
          </Select>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: 1, flexGrow: 1 }}>
          <Typography fontSize={13} sx={{ fontWeight: "bold", color: "green", whiteSpace: 'nowrap' }}>
            ✅ {indicadores.percConcluido}%
          </Typography>
          <Typography fontSize={13} sx={{ fontWeight: "bold", color: "red", whiteSpace: 'nowrap' }}>
            ⏳ {indicadores.percRestante}%
          </Typography>
          <Divider orientation="vertical" flexItem />
          <Typography fontSize={12} sx={{ color: theme.text, whiteSpace: 'nowrap' }}>
            <strong>📅</strong> {indicadores.dataInicioPrevista ? indicadores.dataInicioPrevista.format("DD/MM HH:mm") : "—"}
          </Typography>
          <Typography fontSize={12} sx={{ color: theme.text, whiteSpace: 'nowrap' }}>
            <strong>🏁</strong> {indicadores.dataFimPrevista ? indicadores.dataFimPrevista.format("DD/MM HH:mm") : "—"}
          </Typography>
        </Box>
      </Paper>


      <Box sx={{ display: "flex", gap: 2, flex: 1, minHeight: 0, mb: 1 }}>
        {/* tabela lateral */}
        <Paper sx={{ width: 250, p: 1.5, flexShrink: 0, bgcolor: theme.paper, color: theme.text, border: `1px solid ${theme.border}`, display: 'flex', flexDirection: 'column' }}>
          <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 'bold', color: theme.textSecondary }}>TAREFAS INSERIDAS</Typography>

          <Box sx={{ flex: 1, overflowY: 'auto' }}>

            {(!ordemServico || !ordemServico.procedimentos_tratamento_em_campo || ordemServico.procedimentos_tratamento_em_campo.length === 0) ? (
              <Typography color="text.secondary">Nenhuma tarefa cadastrada</Typography>
            ) : (
              ordemServico.procedimentos_tratamento_em_campo.map((t) => {
                const inicio = parseDataHora(t.data_hora_inicio_prevista);
                const fim = parseDataHora(t.data_hora_fim_prevista);


                const dataExib = inicio ? inicio.format("DD/MM/YYYY") : "Data inválida";
                const inicioExib = inicio ? inicio.format("HH:mm") : "??";

                let fimExib = "??";
                if (fim) {
                  if (!inicio) {
                    fimExib = fim.format("DD/MM/YYYY HH:mm");
                  } else {
                    fimExib = fim.diff(inicio, "day") !== 0 ? fim.format("DD/MM/YYYY HH:mm") : fim.format("HH:mm");
                  }
                }

                return (
                  <Box key={t.id_procedimento_execucao} sx={{ p: 1, mb: 1, borderRadius: 1, border: `1px solid ${theme.border}`, bgcolor: theme.sidebarItem }}>
                    <Typography variant="caption" sx={{ color: theme.text, fontWeight: 'bold', display: 'block' }}>{t.procedimento?.nome || "— sem nome —"}</Typography>
                    <Typography fontSize={11} sx={{ color: theme.textSecondary }}>{dataExib} | {inicioExib} → {fimExib}</Typography>
                  </Box>
                );
              })
            )}
          </Box>
        </Paper>

        {/* gantt */}
        <Paper sx={{ overflowX: "auto", padding: 1, flex: 1, bgcolor: theme.paper, color: theme.text, border: `1px solid ${theme.border}` }}>
          <Box sx={{ display: "flex", gap: 3 }}>
            {chavesOrdenadas.map((chave) => {
              let tarefas = tarefasAgrupadas[chave] || [];
              tarefas = calcularLinhas(tarefas);

              const horarios = gerarHorariosDoDia(tarefas);

              return (
                <Box
                  key={chave}
                  sx={{
                    position: "relative",
                    paddingBottom: 20,
                    width: "max-content !important",
                    minWidth: horarios.length * pixelsPorHora + 20,
                    overflow: "visible !important",
                    display: "block",
                    borderRight: `1px dashed ${theme.border}`,
                    pr: 2
                  }}
                >
                  <Typography sx={{ textAlign: "center", fontWeight: 600, mb: 1, bgcolor: theme.headerBg, color: theme.text, borderRadius: 1 }}>
                    {agruparPorExecutor ? chave : dayjs(chave).format("DD/MM")}
                  </Typography>

                  {/* linha de horários */}
                  <Box
                    sx={{
                      display: "flex",
                      height: 40,
                      width: "max-content",
                      overflow: "visible !important",
                      borderTop: `1px solid ${theme.timelineBorder}`,
                      borderBottom: `1px solid ${theme.timelineBorder}`
                    }}
                  >
                    {horarios.map((dt, i) => {
                      const isNovaData = i > 0 && dt.date() !== horarios[i - 1].date();
                      return (
                        <Box
                          key={i}
                          sx={{
                            width: pixelsPorHora,
                            borderLeft: isNovaData ? `3px solid ${darkMode ? '#90caf9' : '#1976d2'}` : `1px solid ${theme.timelineBorder}`,
                            textAlign: "center",
                            fontSize: 11,
                            lineHeight: "40px",
                            backgroundColor: isNovaData ? theme.timelineActive : theme.timelineSlot,
                            color: theme.text,
                            position: 'relative'
                          }}
                        >
                          {dt.format("HH:mm")}
                          {isNovaData && (
                            <Typography variant="caption" sx={{ position: 'absolute', top: -15, left: 4, fontWeight: 'bold', color: '#1976d2', whiteSpace: 'nowrap' }}>
                              {dt.format("DD/MM")}
                            </Typography>
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                  {/* CSS da animação */}
                  <style>
                    {`
  @keyframes greenPulseMove {
    0% {
      background: linear-gradient(
        90deg,
        rgba(200,247,197,0.3) 0%,
        rgba(76,175,80,0.6) 0%,
        rgba(200,247,197,0.3) 100%
      );
      background-size: 300% 100%;
      background-position: 0% 0%;
    }
    100% {
      background: linear-gradient(
        90deg,
        rgba(200,247,197,0.3) 0%,
        rgba(76,175,80,0.6) 100%,
        rgba(200,247,197,0.3) 200%
      );
      background-size: 300% 100%;
      background-position: -200% 0%;
    }
  }

  .executando-anim {
    animation: greenPulseMove 2.5s linear infinite;
  }
`}
                  </style>
                  {/* tarefas */}
                  <Box
                    sx={{
                      position: "relative",
                      minHeight: 30 * (tarefas.length + 1),
                      mt: 1,
                      width: "max-content",
                      overflow: "visible !important",
                    }}
                  >

                    {tarefas.map((task) => {
                      const style = calcularEstiloGantt(task, horarios);

                      console.log("---- DEBUG DATAS ----");
                      console.log("ID:", task.id);
                      console.log("Inicio RAW:", task.data_hora_inicio_execucao, "TYPE:", typeof task.data_hora_inicio_execucao);
                      console.log("Fim RAW:", task.data_hora_fim_execucao, "TYPE:", typeof task.data_hora_fim_execucao);
                      console.log("----------------------");





                      const colors = getTaskColors(task);
                      // Detecta execução real
                      // Determina estados reais da tarefa
                      const isExecutando =
                        task.status === 0 &&
                        task.data_hora_inicio_execucao !== null;

                      const isExecutado =
                        task.status === 1 ||
                        (task.status === 2 && task.data_hora_inicio_execucao && (task.data_hora_fim_execucao || task.data_hora_execucao)) ||
                        (task.status === 1 && (task.data_hora_fim_execucao || task.data_hora_execucao));

                      const isPausado = task.status === 2;
                      const isCancelado = task.status === 9;


                      const fim = parseDataHora(task.data_hora_fim_prevista)
                        ?.subtract(0, 'minute')
                        ?.format('HH:mm');




                      // Tooltip content
                      const tooltipContent = (
                        <Box
                          sx={{
                            p: 2,
                            maxWidth: 350,
                            color: theme.text,
                            bgcolor: theme.paper,
                            borderRadius: 2,
                            border: `1px solid ${theme.border}`,
                            boxShadow: "0px 2px 10px rgba(0,0,0,0.25)",
                            maxHeight: "40vh",   // ou 400, 500px
                            overflowY: "auto"
                          }}
                        >
                          {/* Título */}
                          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1, color: theme.text }}>
                            📝 {task.procedimento?.nome || "Sem nome"}
                          </Typography>

                          <button
                            onClick={() => handleClickVizualizarProcedimento(task.id)}
                            style={{
                              marginLeft: 8,
                              padding: "2px 6px",
                              fontSize: 10,
                              cursor: "pointer",
                              backgroundColor: darkMode ? "#333" : "#eee",
                              color: theme.text,
                              border: `1px solid ${theme.border}`
                            }}
                          >
                            Abrir {task.id}
                          </button>

                          <Divider sx={{ mb: 1 }} />

                          {/* Início / Fim planejados */}
                          <Typography fontSize={14} sx={{ color: theme.text }}><strong>⏰ Início:</strong> {task.inicio}</Typography>
                          <Typography fontSize={14} sx={{ color: theme.text }}><strong>⏳ Fim:</strong> {fim}</Typography>

                          {/* Criador / Executor */}
                          {task.usuario_criador && (
                            <Typography fontSize={14} sx={{ color: theme.text }}><strong>👤 Criado por:</strong> {task.usuario_criador.nome_amigavel}</Typography>
                          )}

                          {task.usuario_executor && (
                            <Typography fontSize={14} sx={{ color: theme.text }}><strong>👤 Executor:</strong> {task.usuario_executor.nome_amigavel}</Typography>
                          )}


                          <Typography fontSize={14} sx={{ mt: 1, color: theme.text }}>
                            <strong>📌 Status:</strong>{" "}
                            {isExecutando
                              ? "Executando"
                              : isExecutado
                                ? "Executado"
                                : isPausado
                                  ? "Pausado"
                                  : isCancelado
                                    ? "Cancelado"
                                    : "Não Executado"}
                          </Typography>


                          {task.data_hora_inicio_execucao && (
                            <Box sx={{ mt: 2, p: 1, bgcolor: darkMode ? "#1b5e20" : "#f0fff0", borderRadius: 2 }}>
                              <Typography fontSize={14} sx={{ color: theme.text }}>
                                <strong>🚀 Tarefa iniciada em:</strong> {formatarDataHora(task.data_hora_inicio_execucao)}
                              </Typography>
                            </Box>
                          )}

                          {/* EXECUTANDO */}
                          {isExecutando && (
                            <Box sx={{ mt: 2, p: 1.5, bgcolor: darkMode ? "#1b5e20" : "#e6ffec", borderRadius: 2 }}>
                              <Typography fontSize={14} sx={{ fontWeight: "bold", color: darkMode ? "#a5d6a7" : "#004d00" }}>
                                🔄 Em execução no momento
                              </Typography>
                              <Typography fontSize={14} sx={{ color: theme.text }}>
                                <strong>⏱ Iniciado às:</strong> {formatarDataHora(task.data_hora_inicio_execucao)}
                              </Typography>
                            </Box>
                          )}

                          {/* PAUSAS */}
                          {task.data_hora_pausa1 && (
                            <Box sx={{ mt: 2, p: 1, bgcolor: darkMode ? "#422e00" : "#fff7e6", borderRadius: 2 }}>
                              <Typography fontSize={13} sx={{ fontWeight: "bold", color: theme.text }}>⏸ Pausa 1</Typography>
                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>🕒 Data:</strong> {formatarDataHora(task.data_hora_pausa1)}
                              </Typography>
                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>💬 Motivo:</strong> {task.motivo_pausa1 || "—"}
                              </Typography>
                            </Box>
                          )}

                          {task.data_hora_pausa2 && (
                            <Box sx={{ mt: 2, p: 1, bgcolor: darkMode ? "#422e00" : "#fff7e6", borderRadius: 2 }}>
                              <Typography fontSize={13} sx={{ fontWeight: "bold", color: theme.text }}>⏸ Pausa 2</Typography>
                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>🕒 Data:</strong> {formatarDataHora(task.data_hora_pausa2)}
                              </Typography>
                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>💬 Motivo:</strong> {task.motivo_pausa2 || "—"}
                              </Typography>
                            </Box>
                          )}

                          {task.data_hora_pausa3 && (
                            <Box sx={{ mt: 2, p: 1, bgcolor: darkMode ? "#422e00" : "#fff7e6", borderRadius: 2 }}>
                              <Typography fontSize={13} sx={{ fontWeight: "bold", color: theme.text }}>⏸ Pausa 3</Typography>
                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>🕒 Data:</strong> {formatarDataHora(task.data_hora_pausa3)}
                              </Typography>
                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>💬 Motivo:</strong> {task.motivo_pausa3 || "—"}
                              </Typography>
                            </Box>
                          )}

                          {/* CANCELADO */}
                          {isCancelado && (
                            <Box sx={{ mt: 2, p: 1.5, bgcolor: darkMode ? "#420000" : "#ffe8e8", borderRadius: 2 }}>
                              <Typography fontSize={13} sx={{ fontWeight: "bold", color: darkMode ? "#ff9999" : "#7f0000" }}>
                                ❌ Cancelado
                              </Typography>

                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>🕒 Data:</strong> {formatarDataHora(task.data_hora_cancelamento)}
                              </Typography>

                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>💬 Motivo:</strong> {task.mensagem_cancelamento || "—"}
                              </Typography>
                            </Box>
                          )}

                          {/* EXECUTADO */}
                          {isExecutado && (
                            <Box sx={{ mt: 2, p: 1.5, bgcolor: darkMode ? "#003366" : "#e7f7ff", borderRadius: 2 }}>
                              <Typography fontSize={13} sx={{ fontWeight: "bold", color: darkMode ? "#99ccff" : "#003d66" }}>
                                ✅ Execução Concluída
                              </Typography>

                              <Typography fontSize={14}>
                                <strong>▶ Início Exec.:</strong> {formatarDataHora(task.data_hora_inicio_execucao)}
                              </Typography>

                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>⏹ Fim Exec.:</strong> {formatarDataHora(task.data_hora_fim_execucao || task.data_hora_execucao)}
                              </Typography>

                              <Typography fontSize={13} sx={{ color: theme.text }}>
                                <strong>🔧 Resultado:</strong> {task.resultado === 1 ? "Sucesso ✔" : "Falha ❌"}
                              </Typography>

                              {task.observacoes && (
                                <Typography fontSize={13} sx={{ color: theme.text }}>
                                  <strong>📝 Observações:</strong> {task.observacoes}
                                </Typography>
                              )}
                            </Box>
                          )}

                          {!isExecutado && !isExecutando && (
                            <Grid container
                              justifyContent="flex-end"
                              alignItems="center"
                              item xs={12}
                            >
                              <Tooltip title="Excluir procedimento">
                                <IconButton
                                  color="error"
                                  onClick={(event) => handleClickOpenExcluirProcedimento(task)}
                                >
                                  <Delete />
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          )}

                        </Box>
                      );



                      const isOverlapping = agruparPorExecutor && detectOverlap(task, tarefas);
                      const actualBarStyle = calcularEstiloExecucaoReal(task, horarios);

                      return (
                        <Tooltip
                          key={task.id}
                          title={tooltipContent}
                          arrow
                          placement="top"
                          slotProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "transparent",
                                p: 0
                              }
                            }
                          }}
                        >
                          <Box
                            className={
                              (!isExecutado && colors.animating)
                                ? "executando-anim"
                                : ""
                            }
                            sx={{
                              position: "absolute",
                              top: task.linha * 80,
                              height: 70,
                              bgcolor: colors.bg,    // fundo dinâmico
                              color: colors.color,   // texto dinâmico
                              borderRadius: 1,
                              display: "flex",
                              flexDirection: 'column',
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              fontSize: 12,
                              fontWeight: 600,
                              boxSizing: "border-box",
                              overflow: "hidden",
                              border: isOverlapping ? '2px solid #d32f2f' : '1px solid rgba(0,0,0,0.1)',
                              boxShadow: isOverlapping ? '0 0 8px rgba(211,47,47,0.4)' : 'none',

                              ...style,
                            }}
                          >
                            <Box sx={{ px: 1, textAlign: 'center', zIndex: 3 }}>
                              {task.procedimento.nome}
                              {isOverlapping && (
                                <Typography variant="caption" sx={{ display: 'block', color: '#d32f2f', fontSize: '9px' }}>
                                  ⚠️ SOBREPOSIÇÃO
                                </Typography>
                              )}
                            </Box>

                            {/* Barra de Execução Real (Actual) */}
                            {actualBarStyle && (
                              <Box sx={actualBarStyle} />
                            )}
                          </Box>
                        </Tooltip>
                      );
                    })}
                  </Box>

                </Box>
              );
            })}
          </Box>
        </Paper>

      </Box>




      {/* ============================  
    RODAPÉ DO GANTT  
============================ */}
      <Paper
        elevation={1}
        sx={{
          width: "100%",
          mt: 2,
          p: 1,
          bgcolor: theme.paper,
          borderRadius: 2,
          border: `1px solid ${theme.border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        {/* LEGENDA AGRUPADA */}
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1.5, flexWrap: 'wrap' }}>
          {[
            { color: "#FFA726", label: "Pendente", darkColor: "#b87000" },
            { color: "#C8F7C5", label: "Em Exec.", darkColor: "#1b5e20" },
            { color: darkMode ? "#43a047" : "#66BB6A", label: "Sucesso" },
            { color: darkMode ? "#c62828" : "#E53935", label: "Falha" },
            { color: darkMode ? "#d32f2f" : "#FFCDD2", label: "Canc." },
          ].map((item, idx) => (
            <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Box sx={{ width: 12, height: 12, bgcolor: darkMode && item.darkColor ? item.darkColor : item.color, borderRadius: 0.5 }} />
              <Typography fontSize={11} sx={{ color: theme.textSecondary }}>{item.label}</Typography>
            </Box>
          ))}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, ml: 1 }}>
            <Box sx={{ width: 20, height: 4, bgcolor: "#2e7d32", borderRadius: 1 }} />
            <Typography fontSize={11} sx={{ color: theme.textSecondary }}>Progresso Real</Typography>
          </Box>
        </Box>

        {/* CONTADORES COMPACTOS */}
        <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
          <Typography fontSize={12} sx={{ fontWeight: "bold", color: theme.text }}>
            🔄 {tasks.filter(t => t.status === 0 && t.data_hora_inicio_execucao && !t.data_hora_fim_execucao).length}
          </Typography>
          <Typography fontSize={12} sx={{ fontWeight: "bold", color: theme.text }}>
            ⏳ {tasks.filter(t => t.status === 0 && t.data_hora_inicio_execucao === null).length}
          </Typography>
          <Typography fontSize={12} sx={{ fontWeight: "bold", color: theme.text }}>
            ✅ {tasks.filter(t => t.status === 1).length}
          </Typography>
        </Box>
      </Paper>



      {
        ordemServico &&
        (
          <Dialog open={openCadastrarProcedimento} onClose={handleCloseCadastrarProcedimento} >
            <DialogTitle>Cadastrar Procedimento</DialogTitle>
            <DialogContent>
              <Grid
                direction={"row"}
                item xs={12}
                container
                alignItems={'center'}
                justifyContent={'center'}
                spacing={1}
              >

                <CadastrarProcedimentoTratamentoEmCampoAvulso
                  idOrdemServico={ordemServico.id_ordem_servico}
                  tipoProcedimento={3}
                  onClose={handleCloseCadastrarProcedimento}
                />
              </Grid>

            </DialogContent>
          </Dialog>

        )
      }





    </Box>



  );
}
